import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ImageZoomerService} from '../../services/image-zoomer.service';
import {ReportUtils} from '../../libraries/report-utils';

@Component({
  selector: 'app-image-zoomer',
  templateUrl: './image-zoomer.component.html',
  styleUrls: ['./image-zoomer.component.scss']
})
export class ImageZoomerComponent implements OnInit, OnDestroy {

  private _subscription: Subscription;

  public imageUrl: string = null;
  public show: boolean = false;
  public isLoading: boolean = true;

  constructor(
    private imageZoomerS: ImageZoomerService
  ) {
  }

  ngOnInit(): void {
    this._subscription = this.imageZoomerS.getOpen.subscribe((v) => {
      this.imageUrl = v;
      if (v !== null) {
        this.show = true;
      } else {
        this.show = false;
      }
    });
  }

  hideLoader() {
    this.isLoading = false;
  }

  public close() {
    this.imageZoomerS.close();
  }

  public toggle() {
    this.show = !this.show;
  }

  ngOnDestroy(): void {
    ReportUtils.unsubscribe(this._subscription);
  }
}
